import { format } from "date-fns";

// `correctedDate` is an ISO-8601 instant (e.g. "2026-06-26T09:15:00Z") marking
// when a correction (OBR.25='C') superseded the original review. Show only the
// calendar date, formatted the same way (and timezone) as the review date so the
// two read as a consistent provenance pair. Returns null when absent/invalid so
// callers render nothing for uncorrected reviews.
export const formatCorrectedDate = (correctedDate) => {
  if (!correctedDate) return null;

  const parsed = new Date(correctedDate);

  if (Number.isNaN(parsed.getTime())) return null;

  return format(parsed, "dd-MM-yyyy");
};

// The BE submit DTO expects `reviewDate` as a LocalDate (yyyy-MM-dd). On a NEW
// review the FE already holds yyyy-MM-dd, but on EDIT the value is read back from
// the BE as a full ISO datetime (e.g. "2026-06-22T00:00:00Z"), which fails BE
// LocalDate parsing. Take the calendar-date portion verbatim — no timezone
// conversion — so a correction keeps the original treatment date exactly.
export const toReviewLocalDate = (value) => {
  if (!value) return null;

  if (typeof value === "string") return value.slice(0, 10);

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }

  return null;
};
